<template>
    <div class="flex justify-between pt-4">
        <div class="summary text-gray-700 text-16px">
            <template v-if="!loading">
                <template v-if="total == 0">
                    No results found
                </template>
                <template v-else-if="page == 1">
                    Showing {{ totalFormatted }} {{resultsFormattedText}}
                </template>
                <template v-else-if="page > 1">
                    Showing {{ (page - 1) * perPage + 1 }} to {{ (page - 1) * perPage + items.length }} of {{ totalFormatted }} results
                </template>
            </template>
        </div>
        <div class="pagination" v-if="totalPages > 1">
            <pagination-button :disabled="prevButtonDisabled" @click="prev" :is-next-button="false" :loading="prevLoading" />
            <pagination-button :disabled="nextButtonDisabled" @click="next" :is-next-button="true" :loading="nextLoading"/>
        </div>
    </div>

</template>

<script>
import axios from 'axios';
import paginationButton from './PaginationButton.vue';
import {mapWritableState, mapActions} from 'pinia';
import { useGeneralTableStore } from '../../Stores/general_table';

export default {
    components: {
        paginationButton,
    },
    data: () => ({
      nextLoading: false,
      prevLoading: false,  
    }),
    computed: {
        ...mapWritableState(useGeneralTableStore, [
            'data',
            'page',
            'perPage',
            'search',
            'orderBy',
            'orderByDir',
            'loading',
            'items',
            'total',
            'totalPages',
            'totalFormatted',
        ]),
        nextButtonDisabled() {
            return this.page * this.perPage >= this.total;
        },
        prevButtonDisabled() {
            return this.page == 1;
        },
        resultsFormattedText() {
            return this.total == 1 ? 'result' : 'results';
        }
    },
    methods: {
        ...mapActions(useGeneralTableStore, [
            'fetchData',
            'setPage',
        ]),
        next() {
            if (this.page * this.perPage < this.total) {
                if (!this.data[this.page + 1]) {
                    this.nextLoading = true;
                }
                this.setPage(this.page + 1);
            }
        },
        prev() {
            if (this.page > 1) {
                if (!this.data[this.page - 1]) {
                    this.prevLoading = true;
                }
                this.setPage(this.page - 1);
            }
        }
    },
    watch: {
        loading(val) {
            if (!val) {
                this.nextLoading = false;
                this.prevLoading = false;
            }
        }
    }





}

</script>